<button
  mat-button
  class="switcher-trigger"
  [matMenuTriggerFor]="menu"
  (menuOpened)="onMenuOpened()"
  [matTooltip]="'MEETING_ENTITIES.SWITCHER_TOOLTIP' | translate"
>
  <mat-icon>account_tree</mat-icon>
  <span class="label">{{ selectedEntity?.name ?? ('MEETING_ENTITIES.WHOLE_MEETING' | translate) }}</span>
  <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
</button>

<mat-menu #menu="matMenu" class="minutes-document-switcher-menu">
  @if (isSearchable) {
    <div class="search" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      <mat-form-field subscriptSizing="dynamic" appearance="outline">
        <mat-icon matPrefix>search</mat-icon>
        <input
          #searchInput
          matInput
          [(ngModel)]="searchText"
          [placeholder]="'MEETING_ENTITIES.SEARCH_PLACEHOLDER' | translate"
          [attr.aria-label]="'MEETING_ENTITIES.SEARCH_PLACEHOLDER' | translate"
        />
      </mat-form-field>
    </div>
  }
  <button mat-menu-item [class.selected]="selectedMeetingEntityId === null" (click)="select(null)">
    <mat-icon>description</mat-icon>
    <span translate="MEETING_ENTITIES.WHOLE_MEETING"></span>
  </button>
  <mat-divider></mat-divider>
  <div class="entities">
    @for (entity of filteredEntities; track entity.id) {
      <button mat-menu-item [class.selected]="selectedMeetingEntityId === entity.id" (click)="select(entity.id)">
        <mat-icon>{{ statusIcon(entity) }}</mat-icon>
        <span>{{ entity.name }}</span>
      </button>
    } @empty {
      <div class="no-matches" translate="MEETING_ENTITIES.NO_MATCHING_ENTITIES"></div>
    }
  </div>
  @if (canManage) {
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="manage.emit()">
      <mat-icon>tune</mat-icon>
      <span translate="MEETING_ENTITIES.MANAGE"></span>
    </button>
  }
</mat-menu>
